import React, { useState, useEffect } from 'react';
import './shortlistingpopup.css';
import AddFolder from '../../../../../assets/images/Ic_add folder.png';
import ListView from '../../../../../assets/images/Ic_list row.png';
import GridView from '../../../../../assets/images/Ic_grid.png';
import FolderIcon from '../../../../../assets/images/Ic_folder.png';
import { Spinner } from 'react-bootstrap';

const ShortlistingPopup = ({
  isPopupVisible,
  closePopup,
  openNewFolderPopup,
  getFullName,
  folders,
  onSelectFolder,
  isCustomStructure = false,
  forceShowAddFolder = false,
  customHeaderText = null,
  note,
  setNote,

  folderPage,
  setFolderPage,
  folderTotalPages,
}) => {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isPopupVisible) {
      setSelectedFolder(null);
      setErrorMessage('');
      setLoading(false);
      setNote('');
    }
  }, [isPopupVisible, setNote]);



  if (!isPopupVisible) return null;

  const handleFolderClick = (folder) => {
    setSelectedFolder(folder);
    setErrorMessage('');
  };

  const handleYesClick = async () => {
    if (!selectedFolder) {
      setErrorMessage('Please select a folder before shortlisting the candidate.');
      return;
    }

    setLoading(true);
    try {
      await onSelectFolder(selectedFolder);
    } catch (error) {
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleMoveClick = async () => {
    if (!selectedFolder) {
      setErrorMessage('Please select a folder before moving the candidate.');
      return;
    }
    setLoading(true);
    try {
      await onSelectFolder(selectedFolder, note);
    } catch (error) {
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleErrorMessageClose = () => {
    setErrorMessage('');
  };

  const handleFolderPageChange = (page) => {
    setFolderPage(page);

    // call parent api function
    if (folders?.onPageChange) {
      folders.onPageChange(page);
    }
  };

  const renderFolderPageNumbers = () => {
    const pageNumbers = [];
    const current = folderPage + 1;

    if (folderTotalPages <= 5) {
      for (let i = 1; i <= folderTotalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      if (current > 3) {
        pageNumbers.push('...');
      }

      const start = Math.max(2, current - 1);
      const end = Math.min(folderTotalPages - 1, current + 1);

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (current < folderTotalPages - 2) {
        pageNumbers.push('...');
      }

      pageNumbers.push(folderTotalPages);
    }

    return pageNumbers;
  };

  const folderList = folders || [];

  return (
    <div className="profile-work-experience-popup-overlay position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50">
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={handleErrorMessageClose}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="profile-work-experience-popup-container bg-white p-4 rounded" >
        {/* {isCustomStructure && (
          <div className="profile-work-experience-popup-header text-center mb-4">
            <h2>Please select a folder to move the candidate</h2>
          </div>
        )}
        {!isCustomStructure && (
          <div className="profile-work-experience-popup-header text-center mb-4">
            <h2>Please Select The Folder To Shortlist Candidate</h2>
          </div>
        )} */}
        <div className="profile-work-experience-popup-header text-center mb-4">
          <h2>
            {customHeaderText
              ? customHeaderText
              : isCustomStructure
                ? "Please select a folder to move the candidate"
                : "Please Select The Folder To Shortlist Candidate"}
          </h2>
        </div>

        <div className="profile-work-experience-popup-content">
          <div className="profile-work-experience-popup-shortlist-as d-flex align-items-center">
            {isCustomStructure && (
              <label className="me-2">Candidate Name</label>

            )}
            {!isCustomStructure && (

              <label className="me-2">Shortlist As</label>
            )}
            <input
              type="text"
              value={getFullName}
              readOnly
              className="form-control"
            />

          </div>
          <hr className="profile-work-experience-popup-divider" />
          <div className="profile-work-experience-popup-folders">
            <div className="folders-header d-flex justify-content-between align-items-center">
              <h3 className="folders-heading">Folders</h3>

              <div className="folders-actions d-flex align-items-center">
                {(!isCustomStructure || forceShowAddFolder) && (

                  <img
                    src={AddFolder}
                    onClick={openNewFolderPopup}
                    alt="Create Folder"
                    className="folder-action-icon me-2"
                  />
                )}
                {/* <div className="profile-work-experience-popup-vertical-line me-2"></div>
                <img src={ListView} alt="List View" className="folder-action-icon me-2" />
                <img src={GridView} alt="Grid View" className="folder-action-icon" /> */}
              </div>
            </div>
            <label className="folders-label text-start">Name</label>
            <div className="profile-work-experience-folder-table-container">
              <table className="profile-work-experience-folder-table">
                <tbody>
                  {Array.isArray(folderList) &&
                    folderList.map((folder, index) => (
                      <tr
                        key={`${folder.clientId}-${folder.folderName
                          }-${index}`}
                        className={`profile-work-experience-folder-row ${selectedFolder === folder ? 'selected' : ''}`}
                        onClick={() => handleFolderClick(folder)}
                      >
                        <td className="profile-work-experience-folder-cell">
                          <img src={FolderIcon} alt={`${folder.name} Icon`} className="folder-icon" />{' '}
                          <span>{folder.name}</span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          {folderTotalPages > 1 && (
            <div className="d-flex justify-content-center my-3">
              <div className="pagination-container">

                <button
                  onClick={() => handleFolderPageChange(0)}
                  disabled={folderPage === 0}
                >
                  {'<<'}
                </button>

                <button
                  onClick={() =>
                    handleFolderPageChange(Math.max(folderPage - 1, 0))
                  }
                  disabled={folderPage === 0}
                >
                  {'<'}
                </button>

                {renderFolderPageNumbers().map((page, index) => (
                  <button
                    key={index}
                    className={`border rounded p-1 ${folderPage + 1 === page ? 'active' : ''
                      }`}
                    onClick={() => {
                      if (typeof page === 'number') {
                        handleFolderPageChange(page - 1);
                      }
                    }}
                    disabled={typeof page !== 'number'}
                  >
                    {page}
                  </button>
                ))}

                <button
                  onClick={() =>
                    handleFolderPageChange(
                      Math.min(folderPage + 1, folderTotalPages - 1)
                    )
                  }
                  disabled={folderPage >= folderTotalPages - 1}
                >
                  {'>'}
                </button>

                <button
                  onClick={() =>
                    handleFolderPageChange(folderTotalPages - 1)
                  }
                  disabled={folderPage >= folderTotalPages - 1}
                >
                  {'>>'}
                </button>

              </div>
            </div>
          )}
        </div>
        <div className="shortlisting-popup-actions d-flex mt-4">
          <button className="shortlisting-popup-cancel" onClick={closePopup} disabled={loading}>
            Cancel
          </button>
          {!isCustomStructure && (
            <button className="shortlisting-popup-yes" onClick={handleYesClick} disabled={loading}>
              {loading ? (
                <Spinner animation="border" role="status" size="sm" style={{ color: '#F35824', marginRight: '8px' }}>
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                'Yes'
              )}
            </button>
          )}
          {isCustomStructure && (
            <button className="shortlisting-popup-yes" onClick={handleMoveClick} disabled={loading}>
              {loading ? (
                <Spinner animation="border" role="status" size="sm" style={{ color: '#F35824', marginRight: '8px' }}>
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                'Move'
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShortlistingPopup;
